import {Injectable} from '@angular/core';
import {Actions, createEffect,  ofType} from '@ngrx/effects';
import {map, switchMap, tap} from 'rxjs/operators';
import {CustomToastAction, ErrorToastAction, InfoToastAction, SuccessToastAction, toastsAction, ToastsMethodCall, WarningToastAction} from '../actions/toasts';
import {MessageService} from 'primeng/api';
import {of} from 'rxjs';

@Injectable()
export class ToastsEffect {
  // tslint:disable-next-line:no-any
  error$: any = createEffect((): any => { return this.actions$
    .pipe(
      ofType(toastsAction.ERROR),
      map((action: ErrorToastAction) => action.payload),
      switchMap((payload: ToastsMethodCall) =>
        of(this.messageService.add({severity: 'error', summary: payload.title, detail: payload.message, sticky: true, closable: true}))
      ),
    )
  }, { dispatch: false });


  // tslint:disable-next-line:no-any
  info$: any = createEffect((): any => { return this.actions$
    .pipe(
      ofType(toastsAction.INFO),
      map((action: InfoToastAction) => action.payload),
      switchMap((payload: ToastsMethodCall) =>
        of(this.messageService.add({severity: 'info', summary: payload.title, detail: payload.message, closable: true, life: 10000}))
      ),
    )
  }, { dispatch: false });


  // tslint:disable-next-line:no-any
  success$: any = createEffect((): any => { return this.actions$
    .pipe(
      ofType(toastsAction.SUCCESS),
      map((action: SuccessToastAction) => action.payload),
      switchMap((payload: ToastsMethodCall) =>
        of(this.messageService.add({severity: 'success', summary: payload.title, detail: payload.message, closable: true, life: 10000}))
      ),
    )
  }, { dispatch: false });

  // tslint:disable-next-line:no-any
  warning$: any = createEffect((): any => { return this.actions$
    .pipe(
      ofType(toastsAction.WARNING),
      map((action: WarningToastAction) => action.payload),
      switchMap((payload: ToastsMethodCall) =>
        of(this.messageService.add({severity: 'warn', summary: payload.title, detail: payload.message, closable: true, life: 10000}))
      ),
    )
  }, { dispatch: false });

  // tslint:disable-next-line:no-any
  custom$: any = createEffect((): any => { return this.actions$
    .pipe(
      ofType(toastsAction.CUSTOM),
      map((action: CustomToastAction) => action.payload),
      switchMap((payload: ToastsMethodCall) =>
        of(this.messageService.add({severity: 'info', summary: payload.title, detail: payload.message, closable: true, life: 10000}))
      ),
    )
  }, { dispatch: false });


  // tslint:disable-next-line:no-any
  clearAll$: any = createEffect((): any => { return this.actions$
    .pipe(
      ofType(toastsAction.CUSTOM),
      tap(() => this.messageService.clear()),
    )
  }, { dispatch: false });

  constructor(private actions$: Actions, private messageService: MessageService) {}
}
